import { Link } from "react-router-dom";
import UserService from "../services/UserService";

const Menu = () => (
  <nav className="navbar navbar-default" style={{minHeight:'100px'}}>
    <div className="container-fluid" style={{height:'100%',display:"flex", justifyContent:"center",alignItems:"center"}}>
    <div style={{display:"flex", height:'100%',justifyContent:"center",alignItems:"center"}}>
          <Link to="/">
            <img src={"MK-Vision-logo.png" } alt="" style={{maxWidth:185, maxHeight:73}} /></Link>
        </div>
      <div>
        <ul className="nav navbar-nav">
          <li><Link to="/">Công ty Cổ phần MK Vision</Link></li>
        </ul>

        {/*<p className="navbar-text navbar-right" style={{ marginRight: 15 }}>*/}
        {/*  Signed in as {UserService.getUsername()}*/}
        {/*</p>*/}
      </div>
      <button className="btn btn-success navbar-btn navbar-right" style={{ marginRight: "-20px", paddingRight: "-20px" }} onClick={() => UserService.doLogout()}>
          Đăng xuất
        </button>
    </div>
  </nav>
)

export default Menu
